// src/constants/colors.js
export const colors = {
  // Main color palette
  outerBackground: '#ebeef0',    // Light gray - outer background/page background
  innerBackground: '#0f2138',    // Dark blue-gray - hero sections/cards/main content
  accent: '#eb5454',             // Red - buttons, selections, interactive elements
  
  // Derived colors for hover states and variations
  accentHover: '#d63e3e',        // Darker red for hover states
  accentLight: 'rgba(235, 84, 84, 0.1)',  // Light red background
  accentBorder: 'rgba(235, 84, 84, 0.3)',  // Light red border
  
  // Text colors
  textOnLight: '#1a2126',        // Dark text on light backgrounds
  textOnDark: '#ebeef0',         // Light text on dark backgrounds
  textMuted: 'rgba(235, 238, 240, 0.7)',  // Muted text on dark backgrounds
  
  // Additional colors for game states
  success: '#27ae60',            // Green for correct answers, ready states
  warning: '#f39c12',            // Orange for timers, warnings
  error: '#e74c3c',              // Red for errors, wrong answers
  
  // Background variations
  cardBackground: 'rgba(235, 238, 240, 0.1)',     // Light overlay on dark backgrounds
  cardBorder: 'rgba(235, 238, 240, 0.2)',         // Subtle borders
  
  // Interactive states
  buttonDisabled: '#7f8c8d',     // Disabled button color
  inputBorder: '#eb5454',        // Input field borders
  inputBackground: '#ebeef0',    // Input field backgrounds
};